import React from 'react';

import { Colors, IconButton, Icons, createClasses } from '@kp/react-ui';

import { CHAT_FAB_OFFSET, CHAT_Z_INDEX } from './constants';

const classes = createClasses({
  fab: {
    position: 'fixed',
    bottom: `${CHAT_FAB_OFFSET}px`,
    right: `${CHAT_FAB_OFFSET}px`,
    borderRadius: '50%',
    boxShadow: `0 4px 16px color-mix(in srgb, ${Colors.Neutral.borderHeavy} 16%, transparent)`,
    zIndex: CHAT_Z_INDEX,
    width: '56px',
    height: '56px',
  },
});

interface ChatFabProps {
  onClick: () => void;
}

export const ChatFab: React.FC<ChatFabProps> = ({ onClick }) => (
  <IconButton
    icon={Icons.IconAiChat}
    variant="primary"
    size="large"
    className={classes.fab}
    onClick={onClick}
    data-testid="chat-fab"
  />
);
